module.exports = __webpack_public_path__ + "img/wood-duck.1555ac2f.jpg";